import { type Context, createContext } from 'react';

type ChatStartupTiming = {
	startupId: string;
	startedAt: number;
	startBoundary: 'asyncEntryRender' | 'providerRender';
	product: string;
	surface: string;
	committedInitializationEnabled: boolean;
	initialConversationsFetchDeduplicationEnabled: boolean;
	isFirstChatOpen: boolean;
	hiddenDuringStartup: boolean;
	started: boolean;
	finished: boolean;
	readyAt?: number;
	reportUsable?: (readyAt: number) => void;
};

export const ChatStartupTimingContext: Context<ChatStartupTiming | null> =
	createContext<ChatStartupTiming | null>(null);
